import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Leveringsstruktur',
  subtitle: 'Vælg, hvordan ordrer leveres (pr. lokation).',
  form: {
    delivery_mode: {
      label: 'Leveringsmåde',
      placeholder: 'Vælg leveringsmåde',
      options: {
        [DeliveryMode.Internal]: 'Intern (egne chauffører)',
        [DeliveryMode.External]: 'Ekstern (tredjepart)',
      },
    },
  },
  buttons: {
    back: 'Tilbage',
    next: 'Næste',
    skip: 'Spring over',
  },
  toasts: {
    error: 'Noget gik galt. Prøv igen.',
  },
};
